/** @jsx jsx */
import { jsx } from 'theme-ui'
import ListingCardEmbed from '~/components/Listing/Card/Embed'
import PackCardAddToCart from '~/components/Pack/AddToCart/Card'
import PackCallout from '~/components/Pack/Callout'

const PackCardEmbed = ({ pack }) => {
  const {
    cardTag,
    hoverImage,
    mainImage,
    name,
    reviewlessCallout,
    reviewsPack,
    shortDescription,
    slug,
    slugUrl,
    subtitle,
  } = pack

  return (
    <ListingCardEmbed
      addToCart={<PackCardAddToCart pack={pack} />}
      callout={<PackCallout pack={pack} />}
      hoverImage={hoverImage}
      mainImage={mainImage}
      name={name}
      reviewlessCallout={reviewlessCallout}
      reviewsSlug={reviewsPack?.slug}
      shortDescription={shortDescription}
      slug={slug}
      slugUrl={slugUrl}
      subtitle={subtitle}
      tag={cardTag}
    />
  )
}

export default PackCardEmbed
